import { getScore } from "utils/dateTimeUtils";

export const createCelebration = (person, dateType) => ({
  person,
  key: `${person.id}${dateType}`,
  dateType,
  score: getScore(person[dateType]),
});

export const calendarBackgroundColors = (theme) => {
  const { calendarItemBackground } = theme.palette;
  const classes = calendarItemBackground.reduce((itemClass, color, index) => {
    return {
      ...itemClass,
      [`calendarItem${index}`]: `backgroundColor: ${color}`,
    };
  }, {});
  return classes;
};
